module.exports = __webpack_public_path__ + "img/6.86a47a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/academic/6.png
// module id = 591
// module chunks = 5